module.exports = __webpack_public_path__ + "img/aw.e1f41d7f.svg";